import React from 'react';

export default dialogRef => {
  const [isOpen, setIsOpen] = React.useState(false);
  const promiseInfo = React.useRef<{ resolve: Function; reject: Function }>(
    null!,
  );
  const onConfirm = React.useCallback(value => {
    setIsOpen(false);
    promiseInfo.current?.resolve(value);
  }, []);
  const onCancel = React.useCallback(() => {
    setIsOpen(false);
    promiseInfo.current?.resolve();
  }, []);
  React.useImperativeHandle(dialogRef, () => ({
    showDialog: () => {
      setIsOpen(true);
      return new Promise((resolve, reject) => {
        promiseInfo.current = { resolve, reject };
      });
    },
  }));
  return { isOpen, onConfirm, onCancel };
};
